/**
 * AppVersionCreateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AppVersionCreateRes
 */
export interface AppVersionCreateRes {
  /** 版本ID */
  id?: string
}

/**
 * AppVersionCreateRes Schema
 */
export const AppVersionCreateResSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '版本ID',
      format: 'string',
      type: 'string',
      label: '版本ID',
    },
  },
  type: 'object',
}
